import Button from '@r1-frontend/ui-react/components/buttons/button';
import { H4 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph5 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from '~/src/features/full-buy/Banner/styled';

interface IProps {
    title: string,
    subtitle: string,
    onClick: () => void,
    buttonText?: string,
}

export const BannerView = ({ title, subtitle, onClick, buttonText = 'Подключить' }: IProps) => {
    return (
        <ST.BannerBlockContainer
            indent={{ $mobile: [8, 24], $desktop: [16, 24] }}
            rounder={{ $desktop: 32, $mobile: 16 }}
            bgColor={COLORS.BgSurface}
        >
            <ListContainer $size={8} $direction='column'>
                <H4 $smaller $withIndent={false} dangerouslySetInnerHTML={{ __html: title }}/>
                <Paragraph5 dangerouslySetInnerHTML={{ __html: subtitle }}/>
                <IndentContainer $mobile={[16, 0, 12]} $desktop={[8, 0, 8]}>
                    <Button bType='primary' size='small' onClick={onClick}>{buttonText}</Button>
                </IndentContainer>
            </ListContainer>
            <img src={require('~/static/images/full-buy/banner.png')}/>
        </ST.BannerBlockContainer>
    );
};

